import { useState } from "react";
import {
  faExpandAlt,
  faArrowLeft,
  faArrowRight,
  faCompressAlt,
} from "@dreambigger/design-system/src/icons/light";
import { Icon, IconLookup } from "@dreambigger/design-system/src/icons";
import cx from "classnames";
import styles from "./gallery.module.scss";
import { Button, Carousel, Group, Modal } from "@dreambigger/design-system";
import { optimizeCloudinaryImg } from "@dreambigger/shared/src/utils";

// The carousel is spreading props onto the icon and they are erroring.
// We need some of the props removed so they don't error.
const IconWithoutCarouselErrors = ({
  slideCount,
  currentSlide,
  ...props
}: any) => <Icon {...props} />;

const Gallery = ({ images }: { images: string[] }) => {
  const [imageModalVisible, setImageModalVisible] = useState(false);

  const setModalVisible = () => {
    setImageModalVisible(true);
  };
  const setModalHidden = () => {
    setImageModalVisible(false);
  };

  return (
    <Group
      className={cx(styles.carouselWrap, "bg-gray-9 justify-center relative")}
    >
      <Button
        aria-label="image gallery fullscreen"
        icon={<Icon icon={faExpandAlt as IconLookup} />}
        className="bg-white absolute top-4 right-4 z-1"
        onClick={setModalVisible}
      />
      <Carousel
        arrows
        prevArrow={
          <IconWithoutCarouselErrors icon={faArrowLeft} className="bg-white" />
        }
        nextArrow={<IconWithoutCarouselErrors icon={faArrowRight} />}
      >
        {images.map((image) => (
          <Group className="justify-center relative" key={image}>
            {/* Maximized image displayed as a modal */}
            <Modal
              open={imageModalVisible}
              onCancel={setModalHidden}
              className="w-100 max-w-100 h-100vh top-0 ma-0 bg-gray-9 image-modal"
              footer={null}
              closeIcon={
                <Button icon={<Icon icon={faCompressAlt as IconLookup} />} />
              }
            >
              <img
                className="w-100 max-w-100 max-h-100"
                style={{
                  objectFit: "contain",
                }}
                src={optimizeCloudinaryImg(image)}
                alt="gallery image"
                loading="lazy"
              />
            </Modal>

            {/* Normal image display */}
            <img
              className="w-100 max-w-100 max-h-50vh md_max-h-100"
              style={{
                objectFit: "contain",
                height: "calc(100vh - 75px)",
              }}
              src={optimizeCloudinaryImg(image)}
              alt="gallery image"
            />
          </Group>
        ))}
      </Carousel>
    </Group>
  );
};

export default Gallery;
